<template>
  <div class="modal_wrap">
    <div class="modal_title">
      <div>
        <a class="back" @click="guideClose">뒤로</a>
      </div>
      <div class="modal_title_title">
        {{ $t('alarm.price.guide') }}
      </div>
      <div class="colse-btn" @click="guideClose">
        <img
          src="@/assets/images/dark/icon_close.png"
          alt="close button"
        />
      </div>
    </div>

    <main class="modal_content">
        <div v-if="loading" class="pdf-loading-overlay">
            <div class="loading_spinner">
            <div class="loading_circle"></div>
            </div>
        </div>

        <!-- <div v-if="errorMessage" class="pdf-message error">
            {{ errorMessage }}
        </div> -->

        <VuePdfEmbed
            v-if="!errorMessage"
            :source="pdfSource"
            class="pdf-viewer"
            @loaded="handleLoaded"
            @rendered="handleRendered"
            @loading-failed="handleLoadingFailed"
            @rendering-failed="handleRenderingFailed"
        />
    </main>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import VuePdfEmbed from 'vue-pdf-embed';

const router = useRouter();
const { locale } = useI18n();

const loading = ref(true);
const errorMessage = ref('');

const pdfSource = computed(() => {
  const rawLang = locale.value || 'en';

  const languageMap = {
    ko: 'ko',
    en: 'en',
    ja: 'ja',
    zh: 'zh',
  };

  const lang = languageMap[rawLang] || 'en';

  return `/guide/guide_${lang}.pdf`;
});

function handleRendered() {
  loading.value = false;
}

function handleLoadingFailed(error) {
  console.error('PDF 파일 로드 실패:', error);
}

function handleRenderingFailed(error) {
  console.error('PDF 렌더링 실패:', error);
}

function guideClose() {
  router.back();
}
</script>


<style scoped>
.loading_spinner {
    margin-top: 0;
}

.modalBackColor {
    display: block;
}

.modal_wrap {
    display: block;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: var(--main-bgcolor);
    border-radius: 15px 15px 0 0;
    cursor: pointer;
    z-index: 10001;
}

.modal_title {
    padding: 12px 16px;
    border-radius: 0;
    background: var(--Grayscale-Gray100, #121415);

    color: var(--Main, #FFF);

    /* Heading 3 */
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px; /* 154.545% */

    display: flex;
    align-items: center;
    justify-content: space-between;
}

.colse-btn {
    width: 24px;
    height: 24px;
}

.colse-btn img {
    width: 100%;
    height: 100%;
}

.modal_content {
    position: relative; 
    padding-top: 0;
    padding-bottom: 20px;
    height: 100%;
    margin-top: 60px;
}

.pdf-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 100;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  background: var(--main-bgcolor);
}

.back {
    display: block;
    width: 24px;
    height: 24px;
    background: url("@/assets/images/icon/arrow/arrow-left-white.png") no-repeat;
    background-size: 24px;
    text-indent: -9999px;
    font-size: 0;
    cursor: pointer;
}

.pdf-viewer {
  width: 98%;
  margin: 0 auto;
}

.pdf-viewer :deep(canvas) {
  display: block;
  width: 100% !important;
  height: auto !important;
  margin-bottom: 12px;
}
  
</style>